import { BaseMapper } from '../common/BaseMapper'

import { FulfillmentAPI, FulfillmentModel } from './type'

export class FulfillmentMapper extends BaseMapper {
  apiMapper = (fulfillment: FulfillmentAPI): FulfillmentModel => ({
    id: fulfillment.id,
    carrier: fulfillment.carrier,
    tracking_number: fulfillment.tracking_number,
  })

  public static defaultValue: FulfillmentModel = {
    id: 0,
    carrier: '',
    tracking_number: '',
  }
}
